// removed by extract-text-webpack-plugin
module.exports = {"container":"C-aYkwKkbw1jTAgRphghY","text":"_1DzvM6mgUBYqtsgJYNH-8f"};


//////////////////
// WEBPACK FOOTER
// ./src/App/Pages/Exchange/Layout/Idle/styles.css
// module id = 1621
// module chunks = 83